<template>
  <el-select :value="value" :placeholder="computedPlaceholder" v-bind="$attrs" @change="onChange">
    <el-option v-for="item in semesterList" :key="item.PK_Semester_ID" :label="item.SMT_Code" :value="item.PK_Semester_ID" />
  </el-select>
</template>

<script>
import DataSource from '../data/datasource'
import { lang } from '../locale/index'

export default {
  name: 'AcademicYearSelect',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      semesterList: [],
    }
  },
  computed: {
    computedPlaceholder() {
      return this.placeholder || lang('Select Academic Year')
    },
  },
  async created() {
    try {
      const response = await DataSource.shared.getAcademicYearforFourYears()
      if (response) {
        if (response.code === '88') {
          window.location.replace('/')
        } else {
          this.semesterList = response.Table
        }
      }
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    onChange(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },
  },
}
</script>
